export const idx_data_ball_rev = [];

idx_data_ball_rev.push({
  rev: '',
  order_idx: -1,
});

idx_data_ball_rev.push({
  rev: 'High',
  order_idx: 0,
});

idx_data_ball_rev.push({
  rev: 'Medium',
  order_idx: 1,
});

idx_data_ball_rev.push({
  rev: 'Low',
  order_idx: 2,
});
